import React from "react"
import Section from "./section"
import DfbIconButton from "../ui-kit/dfb_icon_button"

const MSocialMediaSubBrand = props => {
  return (
    <Section
      baseClass="m-SocialMediaSubbrand"
      defaultPaddingTop="small"
      data={props}
    >
      <div className="m-SocialMediaSubbrand-wrapper">
        <div className="m-SocialMediaSubbrand-container">
          <div className="m-SocialMediaSubbrand-content">
            <div className="m-SocialMediaSubbrand-title">{props.title}</div>
            <div className="m-SocialMediaSubbrand-socialMedia">
              <div className="dfb-ButtonGroup m-SocialMediaSubbrand-ButtonGroup">
                {props.socialMediaLinks.map((link, index) => (
                  <DfbIconButton
                    key={`social-sharing-icon-${link?.icon.split("dfb-icon-")[1]}`} //ToDo: since social media link does not contain a title it is captured from icon-name
                    add_class={"m-SocialMediaSubbrand-IconButton"}
                    tagName="a"
                    link={link?.url}
                    label={link?.icon.split("dfb-icon-")[1]} //ToDo: since social media link does not contain a title it is captured from icon-name
                    icon_type={link?.icon.split("dfb-icon-")[1]} // TODO: hacky, but works
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MSocialMediaSubBrand
